export enum NewsletterEditType {
  EDIT = 'EDIT',
  REUSE = 'REUSE',
  NEW = 'NEW'
}
